<template>
  <div :class="$style.container">
    <div>
        <TrailWelcome
          v-if="!showDetails"
          @go="readyToGo"
        />

        <TrailPicker :slug="slug" v-else />
    </div>
  </div>
</template>

<script>
import TrailWelcome from '../../trail/TrailWelcome.vue'
import TrailPicker from '../../trail/TrailPicker.vue'

export default {
  name: 'TrailPage',
  components: {
    TrailWelcome,
    TrailPicker,
  },
  metaInfo: () => ({ title: 'Escolher Trilha Profissional | CyberClass' }),
  data() {
    return {
      slug: this.$route.params.slug || null,
      showDetails: !!this.$route.params.slug
    }
  },
  methods: {
    readyToGo() {
      this.showDetails = true
    }
  }
}
</script>

<style module lang="scss">
  @import "~@/components/trail/trail.scss";
</style>